(function () {
    'use strict';

    angular
        .module('salesflare.components.filesCustomfieldDisplay', [])
        .component('sfFilesCustomfieldDisplay', {
            templateUrl: 'app-ajs/components/customfields/filescustomfielddisplay.html',
            controllerAs: 'vm',
            controller,
            bindings: {
                files: '<',
                customfield: '<',
                showFieldsIcon: '<'
            }
        });

    function controller($window, config, utils, $translate) {

        const vm = this;

        vm.download = function (downloadUrl) {

            $window.open(downloadUrl, '_blank', 'noopener');
        };

        vm.convertDate = function (fileDate) {

            const monthNames = [
                $translate.instant('January'),
                $translate.instant('February'),
                $translate.instant('March'),
                $translate.instant('April'),
                $translate.instant('May'),
                $translate.instant('June'),
                $translate.instant('July'),
                $translate.instant('August'),
                $translate.instant('September'),
                $translate.instant('October'),
                $translate.instant('November'),
                $translate.instant('December')
            ];

            if (!fileDate) {
                fileDate = Date.now();
            }

            const date = new Date(utils.UTCDateStringToLocalDateObject(fileDate));
            return monthNames[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear();
        };
    }
})();
